/* Shared browse preference and an explicit, variant-bound cart acknowledgement. */
(() => {
  if (window.NubsConditions) return;
  const clean = value => String(value || '').toLowerCase().replace(/[-_()]+/g,' ').replace(/\s+/g,' ').trim();
  function missing(variant) {
    if (variant?.missingSlipcover === true) return true;
    const values = [variant?.title,variant?.option1,variant?.option2,variant?.option3,...(variant?.selectedOptions || []).map(option=>option.value)];
    if(values.some(value=>/\b(?:missing|without|no) slip\s*cover\b/.test(clean(value))))return true;
    return ['missing','missing slipcover','without slipcover'].includes(clean(variant?.slipcoverStatus));
  }
  function rank(variant) {
    if(missing(variant))return 1000;
    const values=[variant?.title,variant?.option1,variant?.option2,variant?.option3,...(variant?.selectedOptions||[]).map(option=>option.value)].map(clean);
    if(values.includes('new'))return 0;
    for(const [label,score] of [['used like new',20],['used very good',30],['used good',40],['used acceptable',50]])if(values.includes(label))return score;
    return 800;
  }
  function preferred(product) {
    const variants=Array.isArray(product?.variants)?product.variants:[];
    const available=variants.filter(variant=>variant.available!==false);
    return [...available].sort((a,b)=>rank(a)-rank(b))[0] || variants[0] || null;
  }
  let pending=null;
  function confirmMissing(variant,root,trigger) {
    if(!missing(variant))return Promise.resolve(true);
    if(pending)pending(false);
    return new Promise(resolve=>{
      const dialog=document.createElement('dialog');dialog.className='nubs-slipcover-confirm';
      if(typeof dialog.showModal!=='function'){resolve(false);return;}
      const title=document.createElement('h2');title.id='NubsSlipcoverConfirmTitle';title.textContent='Missing slipcover';
      const description=document.createElement('p');description.id='NubsSlipcoverConfirmDescription';description.textContent='This copy does not include the slipcover. Photos showing a slipcover are for reference only.';
      const condition=document.createElement('p');condition.className='nubs-slipcover-confirm__condition';condition.textContent=String(variant.title || 'Selected copy');
      const actions=document.createElement('div');actions.className='nubs-slipcover-confirm__actions';
      const cancel=document.createElement('button');cancel.type='button';cancel.textContent='Cancel';
      const accept=document.createElement('button');accept.type='button';accept.className='btn-upload';accept.textContent='Add without slipcover';
      dialog.setAttribute('aria-labelledby',title.id);dialog.setAttribute('aria-describedby',description.id);
      actions.append(cancel,accept);dialog.append(title,description,condition,actions);
      let settled=false;
      const finish=value=>{
        if(settled)return;settled=true;
        document.removeEventListener('nubs:beforepagechange',leave);window.removeEventListener('pagehide',leave);
        if(dialog.open)dialog.close();dialog.remove();if(pending===finish)pending=null;
        if(trigger?.isConnected)trigger.focus();resolve(value);
      };
      const leave=()=>finish(false);pending=finish;
      cancel.addEventListener('click',leave);accept.addEventListener('click',()=>finish(true));
      dialog.addEventListener('cancel',event=>{event.preventDefault();finish(false);});
      dialog.addEventListener('close',()=>finish(false));
      document.addEventListener('nubs:beforepagechange',leave,{once:true});window.addEventListener('pagehide',leave,{once:true});
      (root || document.body).append(dialog);
      try { dialog.showModal();cancel.focus(); } catch (_) { finish(false); }
    });
  }
  window.NubsConditions={missing,rank,preferred,confirmMissing};
})();
